import classnames from 'classnames/bind'

import styles from './ConditionsPopupRedesign.module.scss'

const cx = classnames.bind(styles)

const OfferPolicyTab = function ({data}) {
  return (
    <div className={cx('offer-policy')}>
      {data.content.policies.map((item, i) => {
        return (
          <div className={cx('section')} key={'section' + i}>
            <h5 className={cx('head')}>{item.label}</h5>
            <p>{item.description}</p>
          </div>
        );
      })}
    </div>
  )
}

export default OfferPolicyTab
